export default __webpack_public_path__ + "static/media/new.77b25315.svg";